import React, { useEffect, useRef, useState } from 'react'
import { Prompt, useHistory } from 'react-router-dom'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

export default function EditorNavigation({ dirty, pending }) {
  const history = useHistory()
  const leaving = useRef(false)
  const [exit, setExit] = useState(null)
  useEffect(() => {
    if (!dirty && !pending) return undefined
    const guard = event => { event.preventDefault(); event.returnValue = '' }
    window.addEventListener('beforeunload', guard)
    return () => window.removeEventListener('beforeunload', guard)
  }, [dirty, pending])
  return <><Prompt when={dirty || pending} message={(target, action) => {
    if (leaving.current) return true
    setExit({ target, action }); return false
  }} />
    <Modal isOpen={Boolean(exit)} toggle={() => setExit(null)}>
      <ModalHeader toggle={() => setExit(null)}>Leave without saving?</ModalHeader>
      <ModalBody>{pending ? 'Saving may still be in progress. Return to this editor to check the same request.' : 'Your changes have not been saved.'}</ModalBody>
      <ModalFooter><button type="button" className="btn btn-light" onClick={() => setExit(null)}>Keep editing</button>
        <button type="button" className="btn btn-primary" onClick={() => {
          leaving.current = true
          const target = exit; setExit(null)
          if (target.action === 'REPLACE') history.replace(target.target); else history.push(target.target)
        }}>Leave page</button></ModalFooter>
    </Modal>
  </>
}
